import React from 'react';
import ContractsFiltersBar from './tableView/ContractsFiltersBar';
import { useContractsList } from '../../contextsProperty/ContextContractsList';
import { ContractsListViewType } from '../../../types/contracts/contractTypes';
import useIsMobile from '../../../customHooks/useIsMobileQuery';
import { getCSSVariable } from '../../../stylesheets/cssVariablesUtils';
import ContractsTable from './tableView/ContractsTable';
import ContractsCards from './tableView/ContractsCards';
import ContractsCalendar from './calendarView/ContractsCalendar';
import '../../../stylesheets/stylesLayout/contracts-page.scss';

const StaticRatesContracts = () => {
    const { visibleView } = useContractsList();

    const mobileBreakpoint = parseInt(getCSSVariable('lg'));
    const isMobile = useIsMobile(mobileBreakpoint);

    return (
        <div className='contracts__page'>
            <ContractsFiltersBar />
            {visibleView === ContractsListViewType.TABLE ? (
                isMobile ? (
                    <ContractsCards />
                ) : (
                    <ContractsTable />
                )
            ) : (
                <ContractsCalendar />
            )}
        </div>
    );
};

export default StaticRatesContracts;
